import { MovieJson } from '../../types/movie';
import { ImmerseCta } from '../../types/contentCta';

type MovieJsonWithOverride = MovieJson & {
  immerseCtaEnUs?: Partial<ImmerseCta>;
};

export const getMoviesJsonForEnUs = (moviesJson: MovieJsonWithOverride[]): MovieJson[] =>
  moviesJson.map(({ immerseCtaEnUs, ...m }) =>
    m.immerseCta && immerseCtaEnUs
      ? {
          ...m,
          immerseCta: {
            ...m.immerseCta,
            ...immerseCtaEnUs,
          },
        }
      : m,
  );
